export function errorLog(...args: any[]) {
  console.error(...args);
}
